import React from 'react';
import { Icon } from '@iconify/react';

const navIcon = props => {
  let navIcons = false;
  if (props.items.icon && !props.items.customIcon) {
    navIcons = (
      <span className="pcoded-micon">
        <i className={props.items.icon} />
      </span>
    );
  } else if (props.items.icon && props.items.customIcon) {
    navIcons = (
      <span className="pcoded-micon">
        <Icon icon={props.items.icon} color={props.items.color} width={props.items.width} height={props.items.height} />
      </span>
    );
  }
  return navIcons;
};

export default navIcon;
